import { globalEndpoints } from "../globalEndpoints";
import { mainApi } from "../mainApi";

const path = "v2/device";
const name = "Device";

export const deviceApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    ...globalEndpoints(builder, path, name, []),
  }),
});

export const {
  useGetAllDeviceQuery,
  useGetByIdDeviceQuery,

  useLazyGetAllDeviceQuery,
  useLazyCompanyCheckQuery,

  useCreateDeviceMutation,
  useUpdateDeviceMutation,
  useDeleteDeviceMutation,
} = deviceApi;
